<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_NAME']"
    />
    <uf_name />

    <HelpFiledStep2
      text="3. Программа финансовой поддержки"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_SUPPORT_PROG_ID']"
    />
    <uf_support_prog_id />

    <div class="content-title content-mb-14">
      4. Оказывал ли региональный фонд развития промышленности методологическую
      и/или информационную помощь при подготовке заявки в Фонд развития
      промышленности
      <span class="icon-warning"></span>
      <VDropdown
        tag="span"
        trigger="click"
        placement="bottom"
        popperClass="custom-popper"
        style="display: inline"
      >
        <a class="icon-help icon-help-l40" />
        <template #popper>
          <div class="custom-popper-content">
            {{ h4tooltip }}
          </div>
        </template>
      </VDropdown>
    </div>
    <uf_is_reg_fond_help></uf_is_reg_fond_help>

    <div class="content-title content-mb-14">
      <span>5</span>. В структуре владения уставным капиталом преобладающее
      участие имеет паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div
      v-if="
        project.UF_SETTING
          .IS_HIDE_PURCHASE_OF_EQUIPMENT_SPECIAL_MANUFACTURE_LIZING !== 1
      "
    >
      <div class="content-title content-mb-14">
        6. Приобретение оборудования для профильных обрабатывающих производств
      </div>
      <select
        :disabled="$parent.projectDisabled"
        v-model="project.UF_LIZING_IS_EQ_IND"
        class="sel-dropdown i-main-style i-wid-13"
        v-on:change="isViewIndustrialChange()"
      >
        <option value="1">Да</option>
        <option value="0">Нет</option>
      </select>
    </div>

    <div
      v-if="project.UF_SETTING.IS_SHOW_NEW_PURCHASE_OF_EQUIPMENT_LIZING == 1"
    >
      <div class="content-title content-mb-14">
        6. Приобретаемое оборудование относится:
      </div>

      <div
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_PURCHASED_EQUIPMENT_ID'
          )
        }"
      >
        <select
          :disabled="$parent.projectDisabled"
          v-model="project.UF_LIZING_PURCHASED_EQUIPMENT_ID"
          class="sel-dropdown i-main-style i-wid-29"
          v-on:change="isViewPurhasedEquipmentChange(); $parent.removeError('PROJECTS', 'LOGIC', 'UF_LIZING_PURCHASED_EQUIPMENT_ID');"
        >
          <option value=""></option>
          <option
            v-for="item in directory.sp_purchased_equipment_lizing"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
          ></option>
        </select>
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_PURCHASED_EQUIPMENT_ID"
            )
          }}
        </div>
      </div>
      <template v-if="idViewEquipmentHeavy == project.UF_LIZING_PURCHASED_EQUIPMENT_ID">
        <br />
        <div
          v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_HEAVY_ID_ARR'
          )
        }"
        >
          <div class="col-xs-12 mycol content-mb-14"><strong>Наименование оборудования</strong></div>
          <br />
          <Multiselect
            label="NAME"
            class="i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
            :limit="10"
            :limitText="filterItemText"
            track-by="ID"
            v-model="project.UF_LIZING_HEAVY_ID_ARR"
            :options="directory.sp_purchased_equipment_lizing_heavy"
            :multiple="true"
            placeholder=""
            @input="$parent.removeError('PROJECTS', 'LOGIC', 'UF_LIZING_HEAVY_ID_ARR');"
          >
            <span slot="noResult">Записи не найдены</span>
          </Multiselect>
          <div class="error-text">
            {{
              $parent.checkErrorText(
                "PROJECTS",
                "LOGIC",
                "UF_LIZING_HEAVY_ID_ARR"
              )
            }}
          </div>
        </div>
      </template>
      <br />
      <div class="col-xs-12 mycol content-mb-14">
        <strong
        >Приобретаемое оборудование включено в реестр российской промышленной
          продукции, в соответствии с постановлением Правительства Российской
          Федерации от 17.07.2015 № 719</strong
        >
      </div>
      <div
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_CONCLUSION_ID'
          )
        }"
      >
        <select
          :disabled="$parent.projectDisabled"
          v-model="project.UF_LIZING_CONCLUSION_ID"
          class="sel-dropdown i-main-style i-wid-29"
        >
          <option value=""></option>
          <option
            v-for="item in directory.sp_purchased_equipment_lizing_zaklucheniya"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
          ></option>
        </select>
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_CONCLUSION_ID"
            )
          }}
        </div>
      </div>
      <br />
    </div>

    <div class="content-title content-mb-14">
      7. Общая стоимость промышленного оборудования, тыс. руб.
    </div>
    <div class="row myrow content-mb-42">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_TOTAL_IE'
          )
        }"
      >
        <vue-numeric
          currency=""
          separator="space"
          v-model="project.UF_LIZING_TOTAL_IE"
          type="text"
          class="i-main-style i-wid-13"
          :disabled="$parent.projectDisabled"
        />
        <div class="error-text">
          {{
            $parent.checkErrorText("PROJECTS", "LOGIC", "UF_LIZING_TOTAL_IE")
          }}
        </div>
      </div>
    </div>

    <div class="content-title content-mb-14">
      8. Аванс лизингополучателя от общей стоимости промышленного оборудования
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <vue-numeric
          currency=""
          separator="space"
          precision="2"
          v-model="project.UF_LIZING_PROCENT"
          type="text"
          class="i-main-style i-wid-13"
          disabled
        />
        %
        <input class="i-main-style i-wid-13" disabled :value="lizingAvans()" />
        тыс. руб.
      </div>
    </div>

    <div class="content-title content-mb-14">
      8.1 Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14">
      9. Сроки займа, мес.
    </div>
    <uf_month_return></uf_month_return>
    <div
      v-if="getProgramCode(this.project.UF_SUPPORT_PROG_ID) === 'cifrovizaciya'"
    >
      <div class="content-title content-mb-14">
        {{ stepNumber(18) }}. Ставка по займу, % годовых
        <VDropdown
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          :distance="25"
          style="display: inline"
        >
          <a class="icon-help" />
          <template #popper>
            <div class="custom-popper-content">
              {{ h18tooltip }}
            </div>
          </template>
        </VDropdown>
      </div>
      <div class="row myrow content-mb-42">
        <div
          class="col-xs-12 mycol"
          v-bind:class="{
            'has-error': $parent.checkErrorField(
              'PROJECTS',
              'LOGIC',
              'UF_STAVKA_PR_YEAR'
            )
          }"
        >
          <select
            :disabled="$parent.projectDisabled"
            v-model="project.UF_STAVKA_PR_YEAR"
            v-on:change="$parent.updateAllSumPercent()"
            class="sel-dropdown i-main-style i-wid-29"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
          <div class="error-text">
            {{
              $parent.checkErrorText("PROJECTS", "LOGIC", "UF_STAVKA_PR_YEAR")
            }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="isViewIndustrial">
      <div class="content-title content-mb-14">
        10. Отрасль промышленности
      </div>
      <uf_industry_id></uf_industry_id>
      <div class="content-title content-mb-14">
        11. Подотрасль промышленности
      </div>
      <uf_sub_industry_id></uf_sub_industry_id>
    </template>
    <template v-if="$parent.project.UF_SETTING && $parent.project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT">
      <div class="content-title content-mb-14">
        <span v-if="isViewIndustrial">12</span><span v-else>10</span>. Информация
        о продукции проекта
        <VDropdown
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          style="display: inline"
        >
          <a class="icon-help icon-help-l40" />
          <template #popper>
            <div class="custom-popper-content">
              Продукты проекта, перечисленные в резюме должны быть синхронизированы с перечнем из финансовой модели
            </div>
          </template>
        </VDropdown>
      </div>
      <ProjectOkpdProducts></ProjectOkpdProducts>
    </template>
    <template v-else>
      <div class="content-title content-mb-14">
        <span v-if="isViewIndustrial">12</span><span v-else>10</span>. Информация
        о продукции (в соответствии с перечнем ОКПД)
      </div>
      <okpd></okpd>
    </template>
    <div class="content-title content-mb-14">
      <span v-if="isViewIndustrial">13</span><span v-else>12</span>. Аннотация
      проекта
    </div>
    <uf_annotation></uf_annotation>
    <div class="content-title content-mb-14">
      <span v-if="isViewIndustrial">14</span><span v-else>13</span>. Имеющийся
      результат по проекту
    </div>
    <uf_available_results></uf_available_results>
    <div class="content-title content-mb-14">
      <span v-if="isViewIndustrial">15</span><span v-else>14</span>. Место
      реализации проекта
    </div>
    <place></place>

    <div class="content-title content-mb-14">
      <span style="float:left;"
      ><span v-if="isViewIndustrial">16</span><span v-else>14</span>.
        Продукция производится на спецтерритории</span
      >
      <span style="float: left;margin-top: 12px;margin-left: 10px;">
        <label class="switch">
          <input type="checkbox" v-model="project.UF_IS_PRODACTION_SP_TERR" />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <SpecialPlace v-if="project.UF_IS_PRODACTION_SP_TERR"></SpecialPlace>

    <div class="content-title content-mb-14">
      <span v-if="isViewIndustrial">17</span><span v-else>15</span>. Поставщики
      оборудования
    </div>
    <subcontractors></subcontractors>

    <div class="content-title content-mb-14">
      <span v-if="isViewIndustrial">18</span><span v-else>16</span>.
      Включение продукции проекта в Перечни критической продукции / отраслевые планы импортозамещения
    </div>
    <import_plan>tree_group_med_oborudovanie</import_plan>

    <template v-if="isViewNDT">
      <HelpFiledStep2
        :text="
        `${
          isViewIndustrial ? 19 : 17
        }. Соответствуют ли технологии, применяемые в рамках проекта, правилам
      НДТ`
      "
        :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_IS_NDT']"
      />
      <uf_is_ndt></uf_is_ndt>
    </template>

    <fieldset
      :disabled="isResumeCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
      <div class="content-title content-mb-14">
        <span v-if="isViewIndustrial && isViewNDT">20</span>
        <span v-else-if="!isViewNDT">19</span>
        <span v-else>18</span>. Бюджет
        проекта в части расходования средств займа Фонда, тыс. руб.
      </div>
      <table class="co-executor" v-if="budgetLoaded">
        <thead>
        <tr>
          <th>№ п/п</th>
          <th>Источники финансирования проекта</th>
          <th>Сумма, тыс. руб.</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in directory.type_source_lizing_budget">
          <td>{{ index + 1 }}</td>
          <td>{{ item.NAME }}</td>
          <td
            v-bind:class="{
                'has-error': hasBudgetLizingError(item.ID, 'UF_VALUE')
              }"
          >
            <input
              class="i-main-style i-co-executor-style"
              type="text"
              v-model="project.BUDGET_LIZING.items[item.ID].UF_VALUE"
              :disabled="
                  item.CODE === 'FRP_RESOURCES' || $parent.projectDisabled
                "
              @keyup="removeBudgetLizingError(item.ID, 'UF_VALUE')"
            />
          </td>
        </tr>
        <tr>
          <td></td>
          <th>Итого:</th>
          <td>
            <input
              class="i-main-style i-co-executor-style"
              type="text"
              :value="lizingBudget()"
              disabled
            />
          </td>
        </tr>
        </tbody>
      </table>
    </fieldset>

    <template v-if="project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1">
      <uf_okpo>
        <span v-if="isViewIndustrial && isViewNDT">21</span>
        <span v-else-if="!isViewNDT">20</span>
        <span v-else>19</span>
        .
      </uf_okpo>
    </template>
    <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
      <div class="content-title content-mb-14">
        <span v-if="isViewIndustrial && isViewNDT">{{ 21 + okpoShift }}</span>
        <span v-else-if="!isViewNDT">{{ 20 + okpoShift }}</span>
        <span v-else>{{ 19 + okpoShift }}</span>
        . Финансовые показатели организации
      </div>
      <financialIndicator></financialIndicator>
    </template>

    <div v-if="project.UF_INDICATOR_VERSION === 1">
      <div v-if="countriesLoaded">
        <div class="content-title content-mb-14">
          <span v-if="isViewIndustrial && isViewNDT && project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">22</span>
          <span v-else-if="isViewNDT && project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">21</span>
          <span v-else-if="isViewNDT">21</span>
          <span v-else-if="!isViewNDT && project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 0">20</span>
          <span v-else>19</span>. Сбыт
          продукции проекта, обеспечивающий выход на целевой объем продаж
        </div>
        <export_countries></export_countries>
      </div>

      <div
        class="row myrow content-mb-42"
        v-if="project.UF_INDICATOR_VERSION === 1"
      >
        <div class="col-xs-12 mycol">
          <textarea
            v-model="project.UF_SALE"
            :disabled="$parent.projectDisabled"
            class="i-main-style t-dop-style i-wid-50"
            placeholder="Укажите планируемые объемы продаж/спроса, наличие инструментов реализации продукции проекта, перечень договоренностей по реализации продукции проекта: соглашения, предварительные соглашения, переговоры и т.п."
          ></textarea>
        </div>
      </div>
    </div>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Okpd from "@/components/project/form/partial/okpd";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import Uf_is_ndt from "@/components/project/form/partial/uf_is_ndt";
import SpecialPlace from "@/components/project/form/partial/SpecialPlace";
import financialIndicator from "@/components/project/form/partial/FinancialIndicator";
import { Dropdown as VDropdown } from "floating-vue";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";
import Uf_okpo from "@/components/project/form/partial/uf_okpo";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";
import Multiselect from "vue-multiselect";

export default {
  name: "step2",
  props: {
    step: {
      type: String,
      required: false
    },
    project: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      default: 10
    }
  },
  components: {
    Uf_okpo,
    Multiselect,
    SpecialPlace,
    Uf_is_reg_fond_help,
    Export_countries,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    ProjectOkpdProducts,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    Uf_is_ndt,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    financialIndicator,
    uf_is_prevails_mutual_invest_fund,
    VueTagsInput,
    VDropdown,
    HelpFiledStep2
  },
  data() {
    return {
      sumRequest: 0,
      selectedTags: [],
      h4tooltip:
        "Успешная реализация Вашего проекта важна для региона. Если Вы хотите предоставить Региональному фонду доступ к текущей заявке, получить консультационную поддержку и помощь, выберите «Да» в выпадающем списке:",
      h14tooltipShow: false,
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      countriesLoaded: false,
      budgetLoaded: false,
      h18tooltip:
        "Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта \"Цифровизация промышленности\"",
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        "                                • Раздел \"ИТ-консалтинг (разработка и системная интеграция)\" рэнкинга \"Список крупнейших российских консалтинговых групп и компаний\" Эксперт-РА (https://raex-a.ru/);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru).",
      isViewIndustrial: true,
      isViewNDT: false,
      idViewEquipmentHeavy: 0
    };
  },
  created() {
    this.siteUrl = AUTH_URL;

    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "start_pokazatel",
      "product_plan_import",
      "sp_ndt",
      "sp_purchased_equipment_lizing",
      "sp_purchased_equipment_lizing_zaklucheniya",
      "sp_purchased_equipment_lizing_heavy"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["type_source_lizing_budget"])
      .then(() => {
        if (
          typeof this.project.BUDGET_LIZING.items === "undefined" ||
          this.project.BUDGET_LIZING.items.length === 0
        ) {
          this.project.BUDGET_LIZING.items = {};
        }
        this.directory.type_source_lizing_budget.forEach(function(item) {
          if (
            typeof this.project.BUDGET_LIZING.items[item.ID] === "undefined"
          ) {
            Vue.set(this.project.BUDGET_LIZING.items, item.ID, {
              ID: 0,
              UF_VALUE: 0
            });
          }
        }, this);
        this.budgetLoaded = true;
      }, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["country"]).then(() => {
      this.project.UF_EXPORT_COUNTRY_ID.forEach(function(cId) {
        this.directory.country.forEach(function(c) {
          if (cId === c.ID) {
            this.selectedTags.push(c.NAME);
          }
        }, this);
      }, this);
      this.countriesLoaded = true;
    }, this);

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {
      }, this);

    this.isViewIndustrialChange();

    this.$store.dispatch(FETCH_DIRECTORY, ["sp_purchased_equipment_lizing"]).then(() => {
      this.directory.sp_purchased_equipment_lizing.forEach(function(c) {
        if (c.CODE == "equipment_for_heavy_engineering_industry") {
          this.idViewEquipmentHeavy = c.ID;
        }
      }, this);
    }, this);


    if (this.project.UF_SETTING.IS_VIEW_LIST_NDT === 1) {
      this.isViewNDT = true;
    }
  },
  methods: {
    hasBudgetLizingError(col, field) {
      if (typeof this.$parent.budgetLizingErrors[col] !== "undefined") {
        if (
          typeof this.$parent.budgetLizingErrors[col][field] !== "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    budgetLizingErrorText(col, field) {
      if (typeof this.$parent.budgetLizingErrors[col] !== "undefined") {
        if (
          typeof this.$parent.budgetLizingErrors[col][field] !== "undefined"
        ) {
          return this.$parent.budgetLizingErrors[col][field];
        }
      }
      return "";
    },
    removeBudgetLizingError(col, field) {
      if (typeof this.$parent.budgetLizingErrors[col] !== "undefined") {
        if (
          typeof this.$parent.budgetLizingErrors[col][field] !== "undefined"
        ) {
          Vue.delete(this.$parent.budgetLizingErrors[col], field);
        }
      }
      return false;
    },
    onTagAdded(slug) {
      if (slug > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.push(
          this.directory.country[parseInt(slug)].ID
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      this.directory.country.forEach(function(c) {
        if (c.NAME === slug) {
          rem = c.ID;
        }
      });
      if (rem > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_EXPORT_COUNTRY_ID.splice(index, 1);
          }
        }, this);
      }
    },
    getProgramCode(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },
    getInfoproductionId(code) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        return t[0].ID;
      }
      return "";
    },
    lizingBudget() {
      let sum = 0;
      this.directory.type_source_lizing_budget.forEach(function(item) {
        if (
          item.CODE === "FRP_RESOURCES" &&
          this.project.BUDGET_LIZING.items[item.ID].UF_VALUE !==
          this.project.UF_SUM_REQUEST
        ) {
          this.project.BUDGET_LIZING.items[
            item.ID
            ].UF_VALUE = this.project.UF_SUM_REQUEST;
        }
        if (this.project.BUDGET_LIZING.items[item.ID].UF_VALUE > 0) {
          sum += parseInt(this.project.BUDGET_LIZING.items[item.ID].UF_VALUE);
        }
      }, this);
      //this.project.UF_LIZING_TOTAL_IE = sum;
      this.lizingProcent(sum);
      console.log(this.directory.type_source_lizing_budget);
      return sum;
    },

    //     lizingAvans(sum) {
    //   this.directory.type_source_lizing_budget.forEach(function(item) {
    //   let sumLiz = 0
    //     if ( item.CODE === "FRP_RESOURCES" ) {
    //         sumLiz += +this.project.BUDGET_LIZING.items[item.ID].UF_VALUE
    //     } else if ( item.CODE === "ORG_RESOURCES") {
    //       sumLiz += +this.project.BUDGET_LIZING.items[item.ID].UF_VALUE
    //     }
    //     this.project.UF_LIZING_PROCENT = (sumLiz / sum) * 100;
    //   return this.project.UF_LIZING_PROCENT;
    //     })
    //   // this.project.UF_LIZING_AVANS =
    //   //   +this.project.BUDGET_LIZING.items[7369151].UF_VALUE +
    //   //   +this.project.BUDGET_LIZING.items[7369153].UF_VALUE;
    //   // return this.project.UF_LIZING_AVANS;
    // },
    lizingAvans() {
      let sum = 0;
      this.directory.type_source_lizing_budget.forEach(function(item) {
        if (item.CODE === "FRP_RESOURCES") {
          sum += +this.project.BUDGET_LIZING.items[item.ID].UF_VALUE;
        } else if (item.CODE === "ORG_RESOURCES") sum += +this.project.BUDGET_LIZING.items[item.ID].UF_VALUE;
      }, this);
      console.log("sumAvnas: ", sum);
      this.project.UF_LIZING_AVANS = sum;
      return this.project.UF_LIZING_AVANS;
    },
    lizingProcent(sum) {
      this.project.UF_LIZING_PROCENT =
        (this.project.UF_LIZING_AVANS / sum) * 100;
      console.log("lizingProcent: ", this.project.UF_LIZING_PROCENT);
      return this.project.UF_LIZING_PROCENT;
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    isViewIndustrialChange() {
      if (this.project.UF_SETTING.IS_CLOSE_INDUSTIAL_LIZING_BY_NOT_EQ === 1) {
        this.isViewIndustrial =
          this.project.UF_LIZING_IS_EQ_IND != 0 ? true : false;
      }
    },
    isViewPurhasedEquipmentChange() {
      let idHeavy = 0;
      this.directory.sp_purchased_equipment_lizing.forEach(function(c) {
        if (c.CODE === "equipment_for_heavy_engineering_industry") {
          idHeavy = c.ID;
        }
      });
      this.idViewEquipmentHeavy = idHeavy;
      return idHeavy;
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    }
    // lizingProcent() {
    //   this.project.UF_LIZING_AVANS = (
    //     (this.project.UF_LIZING_TOTAL_IE / 100) *
    //     parseInt(this.project.UF_LIZING_PROCENT)
    //   ).toFixed(0);
    //   return this.project.UF_LIZING_AVANS;
  },
  //     lizingAvans() {
  //   this.project.UF_LIZING_AVANS = (
  //     +this.project.BUDGET_LIZING.items[7369151].UF_VALUE +
  //     +this.project.BUDGET_LIZING.items[7369153].UF_VALUE
  //   );
  //   return this.project.UF_LIZING_AVANS;
  // },
  //     lizingProcent() {
  //   this.project.UF_LIZING_AVANS = (
  //     +this.project.BUDGET_LIZING.items[7369151].UF_VALUE +
  //     +this.project.BUDGET_LIZING.items[7369153].UF_VALUE
  //   );
  //   return this.project.UF_LIZING_AVANS;
  // }
  computed: {
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    countries() {
      let els = this.directory.country.filter(function(el) {
        for (let i = 0; i < this.project.UF_EXPORT_COUNTRY_ID.length; i++) {
          if (el.ID === this.project.UF_EXPORT_COUNTRY_ID[i]) {
            return true;
          }
        }
        return false;
      }, this);
      return els;
    },
    countryTags() {
      let countries = {};
      this.directory.country.forEach(function(el, k) {
        countries[k] = el.NAME;
      }, this);
      return countries;
    },
    isResumeCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "rezume_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
